export default from './SubmitButton'


// WEBPACK FOOTER //
// ./src/components/Buttons/SubmitButton/index.js